export default "__VITE_ASSET__PgZhW0n6__"